import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const TotalInvestment = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    // dispatch(setNewPurchaseProfile({ ...purchaseProfile, totalInvestment: { ...purchaseProfile.totalInvestment, [key]: value } }))
    dispatch(setLocal(props.PURCHASE_PROFILE, { ...purchaseProfile, totalInvestment: { ...purchaseProfile.totalInvestment, [key]: value } }))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.assets-class.total-investment']}</div>
        <div className="values">
          <div className="subgroup">
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.totalInvestment.from}
                onChange={update('from')}
                placeholder={translations['my-objects.pipeline.assets-class.total-investment.from']}
              />
            </div>
            <div className="element">
              <Input
                type="customNumber"
                symbol={translations['currency.string']}
                value={purchaseProfile.totalInvestment.to}
                onChange={update('to')}
                placeholder={translations['my-objects.pipeline.assets-class.total-investment.to']}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TotalInvestment
